// extracted by mini-css-extract-plugin
export var card = "heroCard-module--card--qNHHx";
export var outCard = "heroCard-module--outCard--EUb+Q";
export var showCenter = "heroCard-module--showCenter--TON9Z";
export var showLeft = "heroCard-module--showLeft--l+O-Y";
export var showRight = "heroCard-module--showRight--w0B5v";
export var label = "heroCard-module--label--3xIn8";
export var pict = "heroCard-module--pict--m8eRB";
export var text = "heroCard-module--text--MPdlf";
export var wrap = "heroCard-module--wrap--IGa9n";